import * as React from 'react';
import apptracker from '@utils/sensor/apptracker';
import * as Events from '@src/utils/sensor/track';
import * as Stores from '../store';
import RuleAtom from './RuleAtom';

const AdvancedRules = () => {
  const meta = Stores.useFilterMeta();
  const [filterValue] = Stores.useFilterValue();
  const advancedValue = Stores.useAdvancedFilterValue();
  const onRemove = Stores.useOnAdvancedFilterAtomRemove();
  const onUpdate = Stores.useOnAdvancedFilterAtomChange();

  if (!advancedValue?.length) return null;

  return (
    <Stores.FilterDialogProvider meta={meta}>
      {advancedValue.map((groupRules, groupIndex) => (
        <React.Fragment key={groupIndex}>
          {groupRules.map((rule, index) => (
            <RuleAtom
              key={index}
              forceActive
              forceShowRelation={!!filterValue.rule.length}
              dimensionReadonly
              valueReadonly
              op={rule.op}
              field={rule.field}
              tagKey={rule.key}
              values={[rule]}
              path={[groupIndex, index] as const}
              onChange={(val) => {
                onUpdate?.(rule, val.op);
                apptracker(Events.FILTER_BUILDER_CHANGE_CONDITION_OPERATOR_ON_ADVANCED_FILTER, {
                  field: val.tagKey || val.field,
                  from: rule.op,
                  to: val.op,
                });
              }}
              onRemove={() => {
                onRemove?.(rule);
                apptracker(Events.FILTER_BUILDER_REMOVE_CONDITION_ITEM_ON_ADVANCED_FILTER, {
                  filter: JSON.stringify(rule),
                });
              }}
            />
          ))}
        </React.Fragment>
      ))}
    </Stores.FilterDialogProvider>
  );
};

export default React.memo(AdvancedRules);
